import { render } from "./SpeakEdit.vue?vue&type=template&id=7fa13707&scoped=true"
import script from "./SpeakEdit.vue?vue&type=script&lang=js"
export * from "./SpeakEdit.vue?vue&type=script&lang=js"

import "./SpeakEdit.vue?vue&type=style&index=0&id=7fa13707&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7fa13707"

export default script